<app-test>
    @if(!evaluation){
    <app-question slot="question" [orderSeed]="showAnswer || shuffled ? undefined : orderSeed" [question]="question"
        [showFlag]="false" (answersSelected)="handleAnswersSelected($event)" />
    } @else {
    <app-answer slot="question" [question]="question" [orderSeed]="!showAnswer || shuffled ? undefined : orderSeed"
        [evaluation]="evaluation" [showFlag]="false" />
    }

    <ng-container slot="buttons">
        @if(evaluation){
        <button class="z-10 blue-button" (click)="reset()">
            Antwort Zurücksetzen
        </button>
        }
        @else if(answers && answers.length > 0) {
        <button class="z-10 blue-button" (click)="submitAnswer()">
            Antwort Überprüfen
        </button>
        } @else {
        <button class="z-10 disabled-button">
            Antwort Überprüfen
        </button>
        }
    </ng-container>
</app-test>